import { ControlledMenu } from '@szhsin/react-menu';
import { Box, Divider } from '@chakra-ui/react';
import FilterByTabs from './filterAtoms/FilterByTabs';
import useFilterConfigs, {
  FilterDropdownProps,
  FilterTabs,
} from './useFilterConfigs';
import FilterActionButtons from './filterAtoms/FilterActionButtons';
import ValueFilter from './filterMolecules/ValueFilter';
import ConditionFilter from './filterMolecules/ConditionFilter';
import ColorFilter from './filterMolecules/ColorFilter';
import FilterSettings from './filterMolecules/FilterAllSettings';

const FilterDropdown: React.FC<FilterDropdownProps> = (props) => {
  const position = {
    x: props.filterDropdownState.x,
    y: props.filterDropdownState.y,
  };

  const {
    switchTab,
    changeCondition,
    changeValue,
    selectValue,
    toggleSelectAll,
    changeFilterSettings,
    clearFilter,
    applyFilter,
    ...state
  } = useFilterConfigs(props);

  const renderTabView = () => {
    switch (state.tab) {
      case FilterTabs.Value:
        return (
          <ValueFilter
            stroke={props.stroke}
            valueMode={state.valueMode}
            cellValues={state.cellValues}
            isDarkTheme={props.isDarkTheme}
            filterValues={state.filterValues}
            selectValue={selectValue}
            toggleSelectAll={toggleSelectAll}
          />
        );
      case FilterTabs.Condition:
        return (
          <ConditionFilter
            condition={state.condition}
            firstText={state.firstText}
            secondText={state.secondText}
            errors={state.errors}
            changeCondition={changeCondition}
            changeValue={changeValue}
          />
        );
      case FilterTabs.TextColor:
      case FilterTabs.FillColor:
        const forFill = state.tab === FilterTabs.FillColor;
        return (
          <ColorFilter
            forFill={forFill}
            stroke={props.stroke}
            colors={forFill ? state.fillColors : state.textColors}
            color={forFill ? state.fillColor : state.textColor}
            changeValue={changeValue}
          />
        );
      case FilterTabs.Settings:
        return (
          <FilterSettings
            filterSettings={state.filterSettings}
            changeFilterSettings={changeFilterSettings}
          />
        );
    }
  };

  return (
    <ControlledMenu
      {...props.filterMenuState}
      anchorPoint={position}
      onClose={props.closeFilterDropdown} //
      // onClose={() => {}}
      overflow="auto"
      onWheel={(e) => e.stopPropagation()}
      unmountOnClose={true}
      menuStyle={{
        background: props.fill,
        color: props.textColor,
        width: '300px',
      }}
      //   menuItemFocus={{
      //     position: 'first',
      //   }}
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
      onKeyDown={(e) => {
        if (e.key !== 'Escape') e.stopPropagation();
      }}
      portal={true}
    >
      <Box padding="2px 5px">
        <FilterByTabs
          switchTab={switchTab}
          activeTab={state.tab}
          condition={state.condition}
          textColor={state.textColor}
          fillColor={state.fillColor}
          valueMode={state.valueMode}
          filterValues={state.filterValues}
          errors={state.errors}
        />
        <Divider my="5px" />

        <Box m="3px 0px">{renderTabView()}</Box>

        <FilterActionButtons
          clearFilter={clearFilter}
          applyFilter={applyFilter}
        />
      </Box>
    </ControlledMenu>
  );
};

export default FilterDropdown;
